export default {
  Get: {
    LIST_OF_HISTORY: 'getListHistories',
    LIST_CHILDREN: 'getListChildren',
    LIST_CHILDREN_BY_PARENT: 'getListChildrenByParent',
    RESET_LIST_HISTORY: 'resetListHistory'
  },
  Set: {
    LIST_OF_HISTORY: 'setListHistories',
    SET_PARAM_MODE: 'setParamMode',
    SET_CHILDREN: 'setChildrenToParent',
    SET_PARENT: 'setCurrentParent',
    EDIT_PROSPECT_HISTORY: 'editProspectHistory'
  }
}